import { useState, useEffect } from "react";
import { apiFetch, type SingleResponse } from "../lib/api.ts";

export interface Category {
  id: number;
  slug: string;
  name: string;
  description: string;
  icon: string;
  display_order: number;
  project_count: number;
}

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiFetch<SingleResponse<Category[]>>("/categories")
      .then((res) => {
        if (cancelled) return;
        setCategories(res.data);
        setError(null);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { categories, loading, error };
}
